import React from 'react';
import { useConnections } from '#src/@connections/use-connections.js';
import { LoadingIndicator, LoadingSkeleton } from '#lib/components/loading.jsx';
import Button from '#lib/components/button.jsx';
import { addClasses } from '#lib/helpers/class.js';
import ConnectionsModal from './connectionsModal.jsx';
import UnlinkModal from './unlinkModal.jsx';
import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import useBillingInfo from '#routes/settings/billing/use-billing-info.js';
import RedirectModal from './redirectModal.jsx';

export default function Connections() {
    const queryClient = useQueryClient();
    const { data, isLoading } = useConnections();
    const [showUnlinkModal, setShowUnlinkModal] = useState(false);
    const [showConnectionsModal, setShowConnectionsModal] = useState(false);
    const [showRedirectModal, setShowRedirectModal] = useState(false);
    const [connectionId, setConnectionId] = useState('');
    const [url, setUrl] = useState('');
    const navigate = useNavigate();
    const { data: billingInfo, ...flags } = useBillingInfo();

    const checkCountry = (e) => {
        e.preventDefault();
        if (billingInfo.country) setShowConnectionsModal(true);
        else setShowRedirectModal(true);
    };

    return isLoading || flags.isLoading ? (
        <LoadingSkeleton className="h-screen flex items-center justify-center">
            <LoadingIndicator />
        </LoadingSkeleton>
    ) : (
        <div className="px-3 flex flex-col pt-[70px] flex flex-col items-center">
            <div className="w-full flex flex-col justify-center items-center">
                <h1 className=" font-black text-2xl text-center"> {_t.connections.title()} </h1>
                <p className="mt-4 font-base text-center"> {_t.connections.description()} </p>
                <p className="mt-1 text-xs text-center mb-6"> {_t.connections.credentialsDisclosure()} </p>
            </div>
            <div>
                <UnlinkModal
                    id={connectionId}
                    isShown={showUnlinkModal}
                    onClose={() => {
                        setShowUnlinkModal(false);
                        queryClient.invalidateQueries({
                            queryKey: ['connections'],
                            queryType: 'all'
                        });
                    }}
                />
                <ConnectionsModal
                    connections={data}
                    isShown={showConnectionsModal}
                    onClose={() => {
                        setShowConnectionsModal(false);
                        queryClient.invalidateQueries({
                            queryKey: ['connections'],
                            queryType: 'all'
                        });
                    }}
                    country={billingInfo.country}
                />
                <RedirectModal
                    isShown={showRedirectModal}
                    onClose={() => {
                        setShowRedirectModal(false);
                    }}
                />
            </div>
            <div className="w-full max-w-[500px] p-3 flex justify-between gap-8 items-center overflow-hidden">
                <p className="sm:text-lg font-semibold whitespace-nowrap text-ellipsis">
                    {_t.connections.connectionHeader()}
                </p>
                <Button onClick={checkCountry} className={addClasses('w-36 min-w-fit')} look="primary">
                    {_t.connections.connectAccount()}
                </Button>
            </div>
            <ul className="w-full flex flex-col justify-center items-center ">
                {data?.map((item) => {
                    return (
                        item.connected && (
                            <li
                                key={item.connectionId}
                                className="w-full max-w-[500px] m-3 p-3 border-2 shadow-lg flex items-center justify-between rounded-lg"
                            >
                                <p className="pl-1 sm:text-lg font-semibold">{item.name}</p>
                                <div>
                                    <a
                                        className="mr-3 min-w-[10%] cursor-pointer"
                                        onClick={() => {
                                            setShowUnlinkModal(true);
                                            setConnectionId(item.connectionId);
                                            setUrl(item.loginEndpoint);
                                        }}
                                    >
                                        {_t.connections.unlinkAccount()}
                                    </a>

                                    <Button
                                        onClick={() => navigate(`/manage/orders/${item.connectionId}`)}
                                        className={addClasses('w-36 min-w-fit')}
                                        look="primary"
                                        key={item}
                                    >
                                        {_t.connections.import()}
                                    </Button>
                                </div>
                            </li>
                        )
                    );
                })}
            </ul>
        </div>
    );
}
